import React, { useContext } from 'react';
import { Box, Grid, Typography, Avatar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  ProfileContext,
  ProfileContextProps,
} from '../../../context/ProfileContext';
import AnklePatrolLogo from '../../../assets/AnklePatrol_Logo_white.png';

const ConsumerDashboardHeader: React.FC = () => {
  const { userProfile } = useContext(ProfileContext) as ProfileContextProps;
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        padding: '10px 20px',
        width: '100%',
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ maxWidth: '1200px', margin: '0 auto' }}
      >
        {/* Logo */}
        <Grid item>
          <Box
            component="img"
            src={AnklePatrolLogo}
            alt="Ankle Patrol Logo"
            sx={{
              height: { xs: '35px', sm: '40px', md: '50px' },
            }}
          />
        </Grid>

        {/* Profile */}
        <Grid item>
          <Grid container alignItems="center">
            <Typography
              sx={{
                color: '#fff',
                marginRight: '10px',
                fontSize: { xs: '0.9rem', sm: '1rem', md: '1.2rem' },
              }}
            >
              {userProfile?.firstName} {userProfile?.lastName}
            </Typography>
            <Avatar
              src={
                userProfile?.profilePic
                  ? userProfile.profilePic
                  : 'https://www.pngitem.com/pimgs/m/146-1468479_my-profile-icon-blank-profile-picture-circle-hd.png'
              }
              sx={{
                width: { xs: '35px', sm: '40px', md: '50px' },
                height: { xs: '35px', sm: '40px', md: '50px' },
                cursor: 'pointer',
              }}
              onClick={() => navigate('/participant/editProfile')}
            />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ConsumerDashboardHeader;
